/**
 * Sitecore looks up this component to provide tokens data
 * Used for registering jss component while writing runtime config to componentFactory.js
 */
function Wildcards() {
  return null;
}

Wildcards.displayName = 'Wildcards';

export default Wildcards;
